import { Component, Input } from '@angular/core';
import { MenuItem } from '../../../core/interfaces/menu-item.interface';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-menu-item',
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule
  ],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss'
})
export class MenuItemComponent {

  @Input({ required: true }) item!: MenuItem;

  constructor(
    private router: Router
  ) { } // Router for isActive check is often injected here

  toggleExpand(event: MouseEvent): void {
    // If the item is a parent, prevent the default link navigation
    if (this.item.isParent) {
      event.preventDefault();
      this.item.expanded = !this.item.expanded;
    }
    // If it's a link, allow navigation, but you might want to collapse others.
  }

  // Placeholder for a real isActive check (requires injecting Router)
  isActive(route: string): boolean {
    // In a real app, use the Router to check if the current URL matches the route
    return this.router.url === route;
    // return false;
  }

}
